import { lazyMountAndShowPhotoPickerDialog } from 'owa-photo-picker-dialog';
import { getUserConfiguration } from 'owa-session-store';

export default async function changePhotoRouteHandler() {
    let userConfiguration = getUserConfiguration();
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (9,10): Object is possibly 'undefined'.
    // @ts-ignore
    if (!userConfiguration.SegmentationSettings.SetPhoto) {
        return;
    }

    await lazyMountAndShowPhotoPickerDialog.importAndExecute();
}
